import store from '@/store';
import { MESSAGE_MP3 } from './global'

export const CONFIG_BLOCK_LIST = [{
  key: 'mine',
  label: '我的账号',
  cpt: 'MyAccount',
}, {
  key: 'common',
  label: '通用设置',
  only_client: true,
  cpt: 'CommonSetting',
}, {
  key: 'private',
  label: '隐私设置',
  cpt: 'PrivacySetting',
}, {
  key: 'audio',
  label: '语音和屏幕共享',
  split: true,
  cpt: 'AudioSetting',
}, {
  key: 'exterior',
  label: '外观',
  cpt: 'ExteriorSetting',
}, {
  key: 'overlay',
  label: '游戏内覆盖',
  only_client: true,
  cpt: 'OverlaySetting',
}, {
  key: 'game',
  label: '游戏识别',
  only_client: true,
  cpt: 'GameRecognitionSetting',
}, {
  key: 'shortcut',
  label: '快捷键',
  cpt: 'ShortcutSetting',
}, {
  key: 'notice',
  label: '通知设置',
  cpt: 'NoticeSetting',
}, {
  key: 'device',
  label: '设备',
  cpt: 'DeviceSetting',
}, {
  key: 'anchor',
  label: '主播模式',
  cpt: 'AnchorSetting',
}, {
  key: 'record',
  label: '录音文件',
  only_client: true,
  cpt: 'AudioRecordSetting',
},{
  key: 'advanced',
  label: '高级设置',
  cpt: 'AdvancedSetting',
}, {
  key: 'invite',
  label: '邀请有礼',
  split: true,
  cpt: 'InviteSetting',
}, {
  key: 'about_heychat',
  label: '关于黑盒语音',
  split: true,
  cpt: 'AboutHeychat',
  tag: {
    val: process.env.IS_CLIENT ? 
    (() => {
      let str = ''
      if (window.asar_version) {
        str += `${window.asar_version}`
      }
      return `v${str}`
    }) : undefined,
  }
}, {
  key: 'feedback',
  label: '问题反馈',
  split: true,
  cpt: 'Feedback',
}, {
  key: 'feedback_history',
  label: '反馈历史',
  cpt: 'FeedbackHistory',
},{
  key: 'reset',
  label: '重置设置',
  // only_client: true,
  split: true,
  cpt: 'Reset',
}]

export const USER_CONFIG_BLACK_MEMBER_LIST = "blacklist";
export const USER_CONFIG_INVISIBLE_MEMBER_LIST = "invisible-list";

export const MESSAGE_FONTSIZE_MARKS = [12, 14, 15, 16, 18, 20, 24];
export const MESSAGE_MARGIN_MARKS = [4, 8, 16, 20, 24];
export const ZOOM_FACTOR_MARKS = [50, 67, 75, 80, 90, 100, 125, 150, 175, 200];
export const PREVIEW_MESSAGE_LIST = [{
  text: '预览聊天字体大小和消息气泡间距',
  time_str: '今天 12:03',
}, {
  text: '设置聊天字体大小后，会改变频道及私聊字体大小',
  time_str: '今天 12:03',
  avatar: 'https://imgheybox.max-c.com/oa/2024/04/07/344e5ea56daded6d233ea29a277f78bc.png'
}, {
  text: '设置消息气泡间距后，会改变频道及私聊气泡间距',
  time_str: '昨天 19:13',
  avatar: 'https://imgheybox.max-c.com/oa/2024/04/07/344e5ea56daded6d233ea29a277f78bc.png'
}]

export const TIP_SOUND_LIST = [{
  name: '消息',
  value: 1,
  path: MESSAGE_MP3
},{
  name: '麦克风静音',
  value: 1,
  path: require('_audio/mic-off.mp3')
},{
  name: '取消麦克风静音',
  value: 1,
  path: require('_audio/mic-on.mp3')
},{
  name: '音量静音',
  value: 1,
  path: require('_audio/volume-off.mp3')
},{
  name: '取消音量静音',
  value: 1,
  path: require('_audio/volume-on.mp3')
},{
  name: '语音连接',
  value: 1,
  path: require('_audio/join-channel.mp3')
},{
  name: '语音连接断开',
  value: 1,
  path: require('_audio/exit-channel.mp3')
},{
  name: '其他用户连接',
  value: 1,
  path: require('_audio/other-user-join.mp3')
},{
  name: '其他用户离开',
  value: 1,
  path: require('_audio/other-user-exit.mp3')
},{
  name: '按键说话',
  value: 1,
  path: require('_audio/key-talk-start.mp3')
},{
  name: '松开按键',
  value: 1,
  path: require('_audio/key-talk-end.mp3')
},{
  name: '录制语音',
  value: 1,
  path: require('_audio/record-start.mp3')
},{
  name: '停止录制',
  value: 1,
  path: require('_audio/record-stop.mp3')
},{
  name: '被抱上麦',
  value: 1,
  path: require('_audio/force-take-mic.mp3')
},{
  name: '申请上麦',
  value: 1,
  path: require('_audio/apply-take-mic.mp3')
},{
  name: '被抱下麦',
  value: 1,
  path: require('_audio/force-drop-mic.mp3')
}]

export const ANCHOR_WHITE_LIST_CONFIG = {
  title: '添加白名单用户',
  desc: '白名单的用户，将不会被主播模式自动静音',
  confirm: {
    text: '保存',
  },
  cancel: {
    text: '取消',
  },
}

export const GAME_CARD_DIALOG_CONFIG = {
  title: "添加名片",
  cancel: {
    text: "取消",
  },
  confirm: {
    text: "添加",
  },
};

export const GAME_PROCESS_DIALOG_CONFIG = {
  title: "添加游戏",
  cancel: {
    text: "取消",
  },
  confirm: {
    text: "添加",
  },
};

export const OBS_AUTH_DIALOG_CONFIG = {
  cancel: {
    text: "后退",
  },
  confirm: {
    text: "授权",
  },
};

// 互相冲突的默认快捷键设置
export const CONFLICT_SHORTCUT_DEFAULT_CONFIG = {
  audio_press_key: [89], // 按键麦快捷键，默认Y
  mic_switch_key: '', // 开关麦快捷键, 默认空
  voice_switch_key: '', // 开关声音快捷键, 默认空
  screenshot_key: '', // 截图快捷键, 默认空
  full_screenshot_key: '', // 全屏截图快捷键，默认空
  anchor_mode_key: '', // 主播模式快捷键，默认空
  roulette_switch_key: [18,192], /// 语音轮盘快捷键, 默认Alt+`
}

export const SHORTCUT_LABEL_CONFIG = {
  audio_press_key: '按键说话快捷键',
  mic_switch_key: '麦克风开启/关闭快捷键',
  voice_switch_key: '静音开启/关闭快捷键',
  screenshot_key: '截图快捷键',
  full_screenshot_key: '全屏截图快捷键',
  anchor_mode_key: '主播模式开启/关闭快捷键',
  roulette_switch_key: '语音轮盘开启/关闭快捷键',
}

// 默认setting_data的生成函数
export const GENERATE_DEFAULT_SETTING_DATA = () => {
  return {
    curMicId: '', // 当前麦克风id
    curVoiceId: '', // 当前扬声器id
    curMicName: '', // 当前麦克风名称
    curVoiceName: '', // 当前扬声器名称
    micDevices: [],
    voiceDevices: [],
  
    micLevel: 100,
    // 是否将micLevel从v1版本调整为v2
    // v1版本为1-100， v2为1-150
    // 具体调整逻辑见getSettingData函数
    is_mic_level_update_v2: true, 
    voiceLevel: 100,
    isOpenVoiceKey: true, // 是否开启语音包快捷键
    isMuteLaughter: false, // 是否免打扰语音包
  
    AEC: true, // 回声消除
    AGC: true, // 自动增益
    ANS: true, // 噪声抑制
    AI_denoiser_V2: true, // ai降噪
    never_show_close_dialog: false, // 是否不再展示关闭弹窗
    never_show_devices_dialog: false, // 是否不再展示新设备弹窗
    close_event: 'hide', // 关闭是隐藏还是关闭
    auto_launch: undefined, // 开机自启
    auto_launch_hide: undefined, // 启动时自动最小化
    audio_press_mode: false, // 是否按键麦
    audio_press_delay: 0, // 按键麦放开按键延迟
    full_screenshot_path: '', // 全屏截图保存路径
    cancel_key: [27], // 取消快捷键
    laughter_key_map: { // 预设的语音包快捷键，alt+shift+f1/f2/f3/f4/f5/f6/f7/f8/f9
      '1697089403245039616': [16, 18, 112],
      '1697089713489317888': [16, 18, 113],
      '1697089815910027264': [16, 18, 114],
      '1697089891164229632': [16, 18, 115],
      '1697090070206484480': [16, 18, 116],
      '1697090157779357696': [16, 18, 117],
      '1697090328449781760': [16, 18, 118],
      '1697090244710502400': [16, 18, 119],
      '1697090422402191360': [16, 18, 120],
    }, // 语音包快捷键
    continuous_key_list: [ // 幻兽帕鲁连点器，默认配置
      {
        "name": "幻兽帕鲁自动长按",
        "trigger_key": [
          112
        ],
        "executed_key": [
          70
        ],
        "enable": true,
        "mode": 0,
        "interval": 100,
        "random_interval": 0,
        "key": 1707122971651
      }
    ],
    show_overlay: false, // 是否展示悬浮窗
    always_show_overlay: false, // 是否一直最小化时保持展示悬浮窗
    show_screen_share_count: true, // 是否展示屏幕共享人数 默认为true
    overlay_scale: 1, // 悬浮窗scale倍率
    // overlay_position: 4, // 悬浮窗位置表示
    overlay_position_v2: { 
      top: '0%', 
      left: '0%', 
    }, // 1.34版本改版之后的悬浮窗显示位置的坐标
    tip_sound_control: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], //提示音控制
    tip_sound_volume: 10,
  
    new_config_clicked_list: [], // 点击过的新标签
  
    // recent_emojis_small_v3: [], // 最近使用小表情
    recent_emojis_small_v4: [], // 最近使用小表情v4版本
    destiny2_padstart: '/j',
    keep_login_state: true, // 是否保持登录，web为30天，客户端为持久化
    hardware_acceleration: true, // 是否开启硬件加速
    member_voice_level: {}, // 频道内每个用户的输出音量数值
    d2_checkpoint_hide: false, // 是否隐藏命运2checkponit错误提示
    hide_friend_types: {}, // 我的好友中隐藏的分区id
    have_accepted_promise: false, //是否接受过邀约
    hide_download_banner: false, //是否应该隐藏下载客户端banner
    bgm_volume: 100, // bgm伴奏音量
    hide_laughter_shortcut_tip: false, // 是否隐藏语音包快捷键提示
    hide_phone_mic_new: false, // 是否隐藏手机端麦克风new标志
    is_tray_flash: true, // 客户端是否展示托盘消息
    never_show_add_channel_friends: false, // 是否不再显示 一键添加当前频道内好友 弹窗
    window_zoom_factor: 100, // 窗口缩放比例
    msg_font_size: 14, // 消息字体大小
    msg_margin: 20, // 消息字体间距
    screen_share_protocol: 'udp', // 屏幕共享使用的网络协议 tcp || udp, 默认udp、
    screen_share_hardware_encode: true, // 屏幕共享启动硬件编码
    mic_input_threshold: -100, // 自定义语音输入阈值
    system_audio_attenuation: 100, // 语音时，将弱化其他应用的音量. 100则不弱化
    system_audio_attenuation_when_self: false, //当我说话时生效弱化
    system_audio_attenuation_when_other: true, //当他人说话时生效弱化
    custom_overlay_setting: {}, // 自定义游戏进程悬浮窗设置
    show_msg_from_channel: true, // 游戏内覆盖展示来自语音频道的消息
    admin_mode_launch: false, // 是否以管理员模式启动
    ignore_proxy: false, // 是否忽略代理
    dns_rewrite: '', // http dsn配置，['', 'ali]
    use_inject_overlay: false, // 是否使用注入悬浮窗
    isOpenLaughterRoulette: false, // 是否启用语音轮盘
    "roulette_switch_key": [18,192], // 语音轮盘默认快捷键
    minimal_query_never_show: false, // 极简模式确认弹窗不再显示
    remember_delete_notify: false, // 频道通知设置移除弹窗的不在提醒
    audio_record_path: '', // 录音保存路径
    pre_record_switch: false, // 是否开启预录
    channel_sidebar_width: 280, // 频道侧边栏宽度
    ...CONFLICT_SHORTCUT_DEFAULT_CONFIG,
  }
}

// 提示音控制的默认值
export const DEFAULT_TIP_SOUND_CONTROL_VALUE = new Array(TIP_SOUND_LIST.length).fill(1)